import dayjs from 'dayjs';
import { useState, useEffect, useRef } from "react";

import { Form, Spin, Card, Tabs, Row, Col, Input } from "antd";
import { PageHeader } from '@ant-design/pro-components';

import { apiCand } from "../../../services/apiCand";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";
import { maskCnpj, maskNumeroProcesso } from "../../../utils/maskFunctions";
import "../style.css";

import CadInfoBotoes from "../Componentes/CadInfoBotoes";
import CertificadorasPerfil from "../Componentes/CertificadorasPerfil"
import CertificadorasTipoCertificado from "../Componentes/CertificadorasTipoCertificado"
import CertificadorasDocumentos from "../Componentes/CertificadorasDocumentos"
import { hasDocMandatory } from "../Utils/Misc"
import { isStateValid, onlyNumbers } from "../../../utils/utilsFunctions";

import { resetColor } from "../../../styles/cnpjColor";
import { errorMessage, mostrarInfo, mostrarInfoDetail, successMessage } from "../../../utils/messages";
import { ITipocertificado, IDocumentoCertificadora, ICertificadora, IAreaCertificadora } from "../Componentes/InterfaceCertificadoras";
import { IErroApi } from "../../../Interfaces/Interfaces";
import { useLocation } from "react-router";
import { IAuditoria } from "../../../Interfaces/DadosPrevicInterfaces";
import Auditoria from "../../../components/Auditoria";
import InfoHistorico from "../../../components/InfoHistorico";
import Watermark from "../../../components/WaterMark";


const Cadastrar = (props: any) => {
  const [form] = Form.useForm();

  const { state } = useLocation();

  const [isDirty, setIsDirty] = useState(false);
  const handlerRef = useRef<(e: BeforeUnloadEvent) => void>(null);

  const [dadosCertificadora, setDadosCertificadora] = useState<ICertificadora>();
  const [tipoCertificados, setTipoCertificados] = useState<ITipocertificado[]>([]);
  const [certificadoraDocumentos, setCertificadoraDocumentos] = useState<IDocumentoCertificadora[]>([]);

  const [areasCertificadoras, setAreasCertificadoras] = useState<IAreaCertificadora[]>([]);

  const [dadosAuditoria, setDadosAuditoria] = useState<IAuditoria[]>([]);
  const [registroHistorico, setRegistroHistorico] = useState<IAuditoria>();
  const [activeKey, setActiveKey] = useState('item-1');

  const [manter, setManter] = useState(2); // 2 : Detalhar / 3 : Alterar / 9 : Histórico
  const [loaded, setLoaded] = useState(false);
  const [erroApi, setErroApi] = useState<IErroApi>()
  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")


  useEffect(() => {
    const storedHistorico = sessionStorage.getItem("registroHistorico");
    if (storedHistorico) {
      sessionStorage.removeItem("registroHistorico"); // optional: avoids reuse on refresh
      let json = JSON.parse(storedHistorico);
      setManter(9);
      setDadosCertificadoraFull(JSON.parse(json.corpoPre));
      setRegistroHistorico(json);
      setActiveKey('item-1');
      window.scrollTo(0, 0)
      mostrarInfo("Registro Histórico", "Você está agora em uma nova janela e vendo um registro histórico. Edições não estão disponíveis");
    } else if (isStateValid(state)) {
      setManter(state.manter)
      setDadosCertificadoraFull(state.data);
    }

    if (form?.getFieldValue("dtCancelamento")) setDesabilitarEditar(true);

    // PREVINE SAIDA DA PÁGINA COM DADOS EM EDIÇÃO
    handlerRef.current = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = ''; // Still required in most browsers
    };

  }, []);

  useEffect(() => {
    if (manter === 2 && dadosCertificadora) { // SE OS DADOS DE CERTIFICADORA JÁ ESTIVEREM PREENCHIDO EXIBIR DETALHES - ESTA AÇÃO DECORRE NORMALMENTE QUANDO SE CANCELA A EDIÇÃO
      setDadosCertificadoraFull(dadosCertificadora);
    }

    if (manter === 3) {
      setActiveKey('item-1');
      setIsDirty(true);
    } else setIsDirty(false);


  }, [manter]);

  useEffect(() => {
    // Verifica se existe registro histórico incompleto. Se sim, consulta o registro novamente para atualizar os dados históricos.
    // Verifica o primeiro e o último registro. Em teoria
    if (!registroHistorico && dadosAuditoria && dadosAuditoria.length > 0) {
      let size = dadosAuditoria.length;
      if (size > 0 && (
        (dadosAuditoria[0].dtPos === undefined || dadosAuditoria[0].dtPos === "")
        || (dadosAuditoria[0].eventos === undefined || dadosAuditoria[0].eventos.length === 0)
      )) {
        getCertificadoraPorId(dadosCertificadora?.idCertificadora);
      }
    }
  }, [dadosAuditoria]);

  useEffect(() => {
    if (registroHistorico && manter !== 9) { // AUDITORIA/HISTÓRICO
      // Save data in sessionStorage
      sessionStorage.setItem("registroHistorico", JSON.stringify(registroHistorico));
      // Open new tab
      window.open("/certificadoras/manter", "_blank");
      setActiveKey('item-1');
    }
  }, [registroHistorico]);

  const getCertificadoraPorId = async (idCertificadora?: number) => {
    try {
      setTipLoading("Atualizando registros históricos");
      setLoading(true);

      let lQuery = `certificadoras/${idCertificadora}/full`;
      const { data } = await apiCand.get(lQuery);
      setDadosCertificadoraFull(data);

    } catch (error) {
      // console.log(error);
      errorMessage("Erro ao atualizar os registros históricos");
    } finally {
      setLoading(false);
    }
  };


  // DESABILITA O BOTÃO EDITAR CASO A DATA DO CANCELAMENTO ESTEJA PREENCHIDA. EM TEORIA, SIGNIFICA QUE O REGISTRO CHEGOU AO SEU FIM E NÃO PODE MAIS SER ALTERADO.
  function desabilitaBtnEditar(title: string, msg: string) {
    if (form?.getFieldValue("dtCancelamento") && form?.getFieldValue("dtCancelamento") !== ""){
      if (hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO]))
        return false;
    }
    return !hasPermissao([Papel.DILIC_MASTER]);
  }

  function verificaTipoCertificados() {  // DEVE EXISTIR PELO MENOS UM TIPO DE CERTIFICADO ATIVO
    let endOk = false;
    if (tipoCertificados && tipoCertificados.length > 0) {
      tipoCertificados.forEach((e: ITipocertificado) => {
        if (e.statusReg === 1) endOk = true;
      });
    }
    return endOk;
  }

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi]);

  function setDadosCertificadoraFull(cert: ICertificadora) {

    form.setFieldsValue({
      "idCertificadora": cert.idCertificadora,
      "nuProcesso": cert.nuProcesso ? maskNumeroProcesso(cert.nuProcesso) : undefined,
      "dtReconhecimento": cert.dtReconhecimento ? dayjs(cert.dtReconhecimento) : undefined,
      "dtCancelamento": cert.dtCancelamento ? dayjs(cert.dtCancelamento) : undefined,
      "canceladoNaBase": cert.dtCancelamento && cert.dtCancelamento !== "" ? true : false,

      "cnpj": maskCnpj( cert?.pessoaJuridica?.cnpj && cert.pessoaJuridica.cnpj !== "" ? cert.pessoaJuridica.cnpj : (cert.cnpj && cert.cnpj !== "" ? cert.cnpj : undefined) ),
      "razaoSocial": cert?.pessoaJuridica?.razaoSocial && cert.pessoaJuridica.razaoSocial !== "" ? cert.pessoaJuridica.razaoSocial : (cert.razaoSocial && cert.razaoSocial !== "" ? cert.razaoSocial : undefined),
    });

    setDadosCertificadora(cert); // RECUPERA OS DADOS DIRETO DA BASE. ESTA ARRAY MANTÉM INTACTO OS DADOS RECEBIDOS DA BASE, QUE PODERÃO SER UTILIZADOS PARA RECUPERAR INFORMAÇÕES EM CASO DE CANCELAMENTO DE EDIÇÃO.

    setTipoCertificados(cert.certificadoraTiposCertificados);
    setCertificadoraDocumentos(cert.certificadoraDocumentos);

    setAreasCertificadoras(cert.certificadoraAreas);

    if (cert.auditoria) setDadosAuditoria(cert.auditoria);

    setLoaded(true);
  }

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [desabilitarEditar, setDesabilitarEditar] = useState(false);

  const [dtCancelamentoIncluida, setDtCancelamentoIncluida] = useState(false);

  useEffect(() => {

    if (dtCancelamentoIncluida && (form?.getFieldValue("dtCancelamento") && form?.getFieldValue("dtCancelamento") !== "")) {
      validaDtCancelamentoTipoCertificado();
    }

  }, [dtCancelamentoIncluida]);

  function verificaDtCancelamento() {
    let ret = false;
    if (dtCancelamentoIncluida) {
      // Verifica se existe um novo documento do tipo nota técnica
      certificadoraDocumentos.forEach((e: IDocumentoCertificadora) => {
        if (e.statusReg === 1 && e.nmDocumento?.toUpperCase() === "NOTA TÉCNICA" && e.idCertificadoraDocumento === -1) {
          ret = true;
        }
      });
    } else {
      ret = true;
    }
    return ret;
  }

  function validaDtReconhecimentoCertificadora(dtReconhecimentoCertificadora: string, tipoCertificados: ITipocertificado[]) {  // NÃO PODE EXISTIR DATA DE RECONHECIMENTO DE CERTIFICADOS MAIOR DO QUE A DATA DE RECONHECIMENTO DA CERTIFICADORA
    let dtOk = true;
    if (tipoCertificados.length > 0) {
      tipoCertificados.forEach((e: ITipocertificado) => {
        if (e.dtReconhecimento && e.dtReconhecimento !== ""){
          // console.log(dayjs(e.dtReconhecimento).format("YYYY-MM-DD"));
          if (dayjs(e.dtReconhecimento).format("YYYY-MM-DD") < dayjs(dtReconhecimentoCertificadora).format("YYYY-MM-DD")){
            dtOk = false;
          }
        }
      });
    }
    return dtOk;
  }

  const validarCertificadora = () => {
    if (!verificaDtCancelamento()) {
      mostrarInfo("Campos inconsistentes", "A inclusão da data de cancelamento de certificadora exige também a inclusão de uma nova nota técnica.");
    } else if (!validaDtReconhecimentoCertificadora(form?.getFieldValue("dtReconhecimento"), tipoCertificados)) {
      mostrarInfo("Erro na data de reconhecimento da certificadora", "A data de reconhecimento da certificadora não pode ser maior do que uma data de reconhecimento de certificado");
    } else if (hasDocMandatory(certificadoraDocumentos) !== 1) {
      mostrarInfo("Erro em documentos", "Um e apenas um documento dentre 'ESTATUTO' e 'CONTRATO SOCIAL' deve ser incluído");
    } else if (!verificaTipoCertificados()) {
      mostrarInfo("Erro em certificados", "Deve existir pelo menos um tipo certificado ativo");
    } else {
      form
        .validateFields([
          "nuProcesso",
          "dtReconhecimento",
          "dtCancelamento",
        ])
        .then(() => {
          sendForm();
        })
        .catch((error) => {
          errorMessage("Campo obrigatório não preechido");
        });

    }

  };

  const ajustaDtCancelamentoTipoCertificado = () => {
    return tipoCertificados.map(tpCert => {
      if (!tpCert.dtCancelamento || tpCert.dtCancelamento === undefined || tpCert.dtCancelamento === "") {
        return ({
          idTpCertificado: tpCert.idTpCertificado,
          nmCertificado: tpCert.nmCertificado,
          teCodigo: tpCert.teCodigo,
          teDetalhamento: tpCert.teDetalhamento,
          dtReconhecimento: tpCert.dtReconhecimento,
          // INCLUI A DATA DE CANCELAMENTO DA CERTIFICADORA NOS CERTIFICADOS.
          dtCancelamento: form?.getFieldValue("dtCancelamento") ? dayjs(form?.getFieldValue("dtCancelamento")).format("YYYY-MM-DD") : "",
          areas: tpCert.areas,
          documentos: tpCert.documentos,
          statusReg: 1,
          touched: true,
          emEdicao: false,
        })
      } else {
        return tpCert
      }
    })
  };

  const validaDtCancelamentoTipoCertificado = () => {
    tipoCertificados.forEach(tpCert => {
      if (!tpCert.dtCancelamento || tpCert.dtCancelamento === undefined || tpCert.dtCancelamento === "") {
        //console.log(tpCert.dtReconhecimento)
        //console.log(form?.getFieldValue("dtCancelamento"))
        if (tpCert.dtReconhecimento) {
          if (form?.getFieldValue("dtCancelamento") < dayjs(tpCert.dtReconhecimento)) {
            errorMessage("Data de cancelamento da certificadora não pode ser menor do que data de reconhecimento de um certificados ativo.");
            form.setFieldsValue({
              "dtCancelamento": undefined,
            });
            setDtCancelamentoIncluida(false);
          }
        }
      }
    })
  };


  const sendForm = async () => {
    setTipLoading("Salvando dados ...");
    setLoading(true);
    const certificadoraPerfil = form.getFieldsValue();
    const json: ICertificadora = {
      idCertificadora: form?.getFieldValue("idCertificadora"),
      nuProcesso: onlyNumbers(certificadoraPerfil.nuProcesso) || "",
      cnpj: certificadoraPerfil.cnpj,
      dtReconhecimento: dayjs(certificadoraPerfil.dtReconhecimento).format("YYYY-MM-DD"),
      dtCancelamento: certificadoraPerfil.dtCancelamento ? dayjs(certificadoraPerfil.dtCancelamento).format("YYYY-MM-DD") : undefined,
      statusReg: 1,
      certificadoraDocumentos: certificadoraDocumentos.map((e: IDocumentoCertificadora) => {
        return {
          ...e
        };
      }),
      certificadoraAreas: areasCertificadoras.map((e: IAreaCertificadora) => {
        return ({
          ...e,
        })
      }),
      certificadoraTiposCertificados: ajustaDtCancelamentoTipoCertificado(),
    };

    // console.log("json atualização subindo")
    // console.log(json);

    await apiCand.put(`/certificadoras/${form?.getFieldValue("idCertificadora")}`, json).then((response) => {
      setLoading(false);
      successMessage(
        `Certificadora ${form?.getFieldValue("razaoSocial").toUpperCase()} atualizada com Sucesso`
      );
      resetForm();

      setManter(2) // VOLTA AO ESTADO INICIAL

      getCertificadoraPorId(response.data.idCertificadora);

      if (form?.getFieldValue("dtCancelamento")) setDesabilitarEditar(true);

    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });

  };

  const resetForm = () => {
    setLoading(true);
    //    form.resetFields();
    setCertificadoraDocumentos([]);
    setDadosCertificadora(undefined);

    form.setFieldsValue({
      "idCertificadora": undefined,
      "nuProcesso": "",
      "dtReconhecimento": undefined,
      "dtCancelamento": undefined,
    });
    setLoading(false);
    window.scrollTo(0, 0)
  };

  // Add/remove event listener based on `isDirty`
  useEffect(() => {
    const handler = handlerRef.current!;
    if (isDirty) {
      window.addEventListener('beforeunload', handler);
    } else {
      window.removeEventListener('beforeunload', handler);
    }

    // Cleanup when component unmounts
    return () => {
      window.removeEventListener('beforeunload', handler);
    };
  }, [isDirty]);

  return (
    <>
      {/* <Prompt
        when={manter === 3}
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}

      <Watermark display={manter === 9 ? "inline" : "none"} />

      <Spin spinning={loading} tip={tipLoading}>
        <PageHeader
          className="site-page-header"
          title={
            (() => {
              switch (manter) {
                case 1:
                  return "Cadastrar Certificadora"
                case 2:
                  return "Detalhar Certificadora"
                case 3:
                  return "Alterar Certificadora"
                case 9:
                  return "Histórico Certificadora"
                default:
                  return null
              }
            })()}
          style={{
            marginTop: "-18px",
            background: "#2160BD",
            padding: 5,
            paddingLeft: 24,
          }}
        />


        <Card title="Informações Básicas" variant="borderless" style={{ width: "100%" }}>

          <Form
            layout='vertical'
            form={form}
            style={{ padding: 24 }}
            // initialValues={{ remember: false }}
            onFinish={validarCertificadora}
            scrollToFirstError
          >

            <Row>
              <Col xs={24} sm={8}>
                <Form.Item label="CNPJ" name="cnpj">
                  <Input disabled={true} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={16}>
                <Form.Item label="Razão Social" name="razaoSocial">
                  <Input disabled={true} />
                </Form.Item>
              </Col>
            </Row>

            <Card title={"Perfil da Certificadora"}>
              <>
                <CertificadorasPerfil
                  setAreasCertificadoras={setAreasCertificadoras}
                  areasCertificadoras={areasCertificadoras}
                  form={form}
                  tipoCertificados={tipoCertificados}
                  setDtCancelamentoIncluida={setDtCancelamentoIncluida}
                  manter={manter}
                  loaded={loaded}
                />
              </>
            </Card>

            <Tabs activeKey={activeKey} onChange={setActiveKey} style={{ display: form?.getFieldValue("idCertificadora") && Number(form?.getFieldValue("idCertificadora")) !== 0 ? "inline" : "none" }}>

              <Tabs.TabPane tab="Certificados" key="item-1">
                <>
                  <CertificadorasTipoCertificado
                    tipoCertificados={tipoCertificados}
                    setTipoCertificados={setTipoCertificados}
                    form={form}
                    manter={manter}
                    areasCertificadoras={areasCertificadoras}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Documentação" key="item-2">
                <>
                  <CertificadorasDocumentos
                    documentos={certificadoraDocumentos}
                    setDocumentos={setCertificadoraDocumentos}
                    form={form}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane disabled={manter !== 2} tab="Histórico" key="item-99" >
                <>
                  <Auditoria
                    dadosAuditoria={dadosAuditoria}
                    setRegistroHistorico={setRegistroHistorico}
                  />
                </>
              </Tabs.TabPane>

            </Tabs>

            <div style={{ display: manter === 9 ? 'inline' : 'none' }}>
              <InfoHistorico form={form} registroHistorico={registroHistorico} />
            </div>

            <CadInfoBotoes
              resetForm={resetForm}
              detalhar={false}
              form={form}
              desabilitaBtnEditar={desabilitaBtnEditar}
              // desabilitaBotoes={desabilitaBotoes}
              resetColor={resetColor}
              manter={manter}
              setManter={setManter}
              checkedValues={areasCertificadoras}
            />

          </Form>
        </Card>
      </Spin>

    </>
  );
};

export default Cadastrar;